import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
// import { IOrganization } from "../organizationModel";

export const getRenewHistory = createAsyncThunk(
  "Organization/GetCompanyHistory",
  async (OrganizationID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/GetCompanyHistory`,
        {
          OrganizationID: OrganizationID,
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertCompanyInfo = createAsyncThunk(
  "Organization/InsertCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/InsertCompanyInfo`,
        BranchData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getCompanyDetails = createAsyncThunk(
  "Organization/GetCompanyInfoDetails",
  async (OrganizationID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/GetCompanyInfoDetails`,
        {
          OrganizationID: OrganizationID,
        },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        RegistrationDate: result?.RegistrationDate
          ? moment(result?.RegistrationDate, "YYYY-MM-DD").toDate()
          : "",
        CompanyName: result?.CompanyName,
        GSTNo: result?.GSTNo,
        Address: result?.Address,
        CityID: result?.CityID,
        CityName: result?.CityName,
        City: result?.City,
        StateID: result?.StateID,
        StateName: result?.StateName,
        State: result?.State,
        ContactPerson: result?.ContactPerson,
        EmailID: result?.EmailID,
        MobileNo: result?.MobileNo,
        TotalUser: result?.TotalUser,
        PaymentType: result?.PaymentType,
        Amount: result?.Amount,
        ExpiryDate: result?.ExpiryDate
          ? moment(result?.ExpiryDate, "YYYY-MM-DD").toDate()
          : "",
        CreatedBy: result?.CreatedBy,
        CreatedDate: result?.CreatedDate
          ? moment(result?.CreatedDate, "YYYY-MM-DD").toDate()
          : "",
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertRenewForm = createAsyncThunk(
  "Organization/InsertRenewCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/InsertRenewCompanyInfo`,
        BranchData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateRenewForm = createAsyncThunk(
  "Organization/UpdateRenewCompanyInfo",
  async (BranchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/UpdateRenewCompanyInfo`,
        BranchData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getRenewDetails = createAsyncThunk(
  "Organization/FindByIDRenewCompanyInfo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/FindByIDRenewCompanyInfo`,
        {
          ID: ID,
        },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        RenewDate: result?.RenewDate
          ? moment(result?.RenewDate, "YYYY-MM-DD").toDate()
          : "",
        TotalUser: result?.TotalUser,
        PaymentType: result?.PaymentType,
        Amount: result?.Amount,
        Remarks: result?.Remarks,
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
